import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home/index'
import news from '@/pages/news/index'
import newsDetail from '@/pages/newsDetail/index'
import product from '@/pages/product/index'
import about from '@/pages/about/index'
import join from '@/pages/join/index'
Vue.use(Router)

export default new Router({
	routes: [
	     {
			path: '/',
			name: 'home',
			component: home,
		},
		{
			path: '/news',
			name: 'news',
			component: news,
		},
		{
			path: '/newsDetail',
			name: 'newsDetail',
			component: newsDetail, 
		},
		{
			path: '/product',
			name: 'product',
			component: product, 
		},
		{
			path: '/join',
			name: 'join',
			component: join, 
		},
		{
			path: '/about',
			name: 'about',
			component: about, 
		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js